export default "__VITE_ASSET__0df59c06__"